var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlay = function SvgPlay(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.8482 5.44503L7.57229 2.81372C5.54849 1.5683 4.53659 0.945595 3.7683 1.37492C3 1.80424 3 2.99239 3 5.36869V10.6313C3 13.0076 3 14.1958 3.7683 14.6251C4.53659 15.0544 5.54849 14.4317 7.57229 13.1863L11.8482 10.555C13.708 9.41045 14.6379 8.83819 14.6379 8C14.6379 7.16181 13.708 6.58955 11.8482 5.44503Z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlay);
export { ForwardRef as ReactComponent };